import { Action } from 'redux';

export enum Types {
  MARKET_SCAN_RESULT_LOADED = 'MARKET_SCAN_RESULT_LOADED',
  UPDATE_MARKET_SCAN_RESULT_LOCAL = 'UPDATE_MARKET_SCAN_RESULT_LOCAL',
  SHOW_HOW_TO_VIDEOS_POPUP = 'SHOW_HOW_TO_VIDEOS_POPUP',
  HIDE_HOW_TO_VIDEOS_POPUP = 'HIDE_HOW_TO_VIDEOS_POPUP',
}

export interface IMarketScanResultLoaded extends Action {
  type: Types.MARKET_SCAN_RESULT_LOADED;
  data: any;
}

export interface IUpdateMarketScanResultLocal extends Action {
  type: Types.UPDATE_MARKET_SCAN_RESULT_LOCAL;
  data: any;
}

export interface IShowHowToVideosPopup extends Action {
  type: Types.SHOW_HOW_TO_VIDEOS_POPUP;
}

export interface IHideHowToVideosPopup extends Action {
  type: Types.HIDE_HOW_TO_VIDEOS_POPUP;
}

export const MarketScanResultLoaded = (
  data: any,
): IMarketScanResultLoaded => ({
  type: Types.MARKET_SCAN_RESULT_LOADED,
  data,
});

export const UpdateMarketScanResultLocal = (
  data: any,
): IUpdateMarketScanResultLocal => ({
  type: Types.UPDATE_MARKET_SCAN_RESULT_LOCAL,
  data,
});

export const ShowHowToVideosPopup = (): IShowHowToVideosPopup => ({
  type: Types.SHOW_HOW_TO_VIDEOS_POPUP,
});

export const HideHowToVideosPopup = (): IHideHowToVideosPopup => ({
  type: Types.HIDE_HOW_TO_VIDEOS_POPUP,
});